module.exports = __webpack_public_path__ + "img/j_cuervo.b863493a.png";